// global selectors
const body = document.body
const select = (e) => document.querySelector(e)
const selectAll = (e) => document.querySelectorAll(e)
const selectId = (id) => document.getElementById(id)

// init lucide
function initLucide() {
	lucide.createIcons()
}
 
// init all click, mouseover and keyup functions
function initClickAndKeyFunctions() {

	// dev mode
	function toggleDevGrid() {
		const devGrid = document.querySelector('.dev-grid')
		if (devGrid) {
			devGrid.classList.toggle('active')
		}
	}

	document.addEventListener('keydown', function(e) {
		if (e.key && e.key.toLowerCase() === 'g' && e.shiftKey) {
			toggleDevGrid()
		}
	})

	// accordion
	selectAll('.accordion').forEach(accordion => {

		const item = accordion
		const question = accordion.querySelector('.question')

		question.addEventListener('click', function(e) {
			e.preventDefault()
			item.classList.toggle('active')
		})
	})

	// show / hide password
	selectAll('.show-pass').forEach(btn => {
		btn.addEventListener('click', function(e) {
			e.preventDefault()
			this.classList.toggle('hidden')

			setTimeout(() => {
				const input = this.parentElement.querySelector('input')
				if (this.classList.contains('hidden')) {
					input.setAttribute('type', 'text')
				} else {
					input.setAttribute('type', 'password')
				}
			}, 30)
		})
	})

	// make anchor links scroll smoothly
	selectAll('.sliding-link').forEach(link => {
		link.addEventListener('click', function(e) {
			e.preventDefault()
			const targetId = this.getAttribute('href')
			const targetElement = document.querySelector(targetId)
			
			if (targetElement) {
				targetElement.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				})
			}
		})
	})

	// open fs
	document.querySelectorAll('.open-fs').forEach(function(el) {
		el.addEventListener('click', function() {
			const tl = gsap.timeline()

			tl.to('body', {
				overflow: 'hidden',
				duration: 0
			})

			tl.to('#fs-menu', {
				opacity: 1,
				visibility: 'visible',
				duration: 0
			})

			tl.to('.blur', {
				opacity: 1,
				pointerEvents: 'auto',
				duration: .3
			})

			tl.to('#fs-menu', {
				transform: 'none',
				duration: .3
			}, '-=.3s')
		})
	})

	// close fs
	function closeFs() {
		const tl = gsap.timeline()

		tl.to('body', {
			overflow: 'auto',
			duration: 0
		})

		tl.to('.blur', {
			opacity: 0,
			pointerEvents: 'none',
			duration: .3
		})

		tl.to('#fs-menu', {
			transform: 'translateX(110%)',
			duration: .3
		}, '-=.3s')

		tl.to('#fs-menu', {
			opacity: 0,
			visibility: 'hidden',
			duration: .3
		}, '-=.2s')

		tl.to('.blur', {
			pointerEvents: 'none',
			duration: 0
		})
	}

	// close fs on click
	const closeSelectors = [
		'.close-fs',
		'#fs-menu a',
		'.blur'
	]
	
	closeSelectors.forEach(selector => {
		selectAll(selector).forEach(el => {
			el.addEventListener('click', function() {
				closeFs()
			})
		})
	})

	// open / close cart menu
	document.querySelectorAll('.open-cart').forEach(function(el) {
		el.addEventListener('click', function() {
			
			openCart()
			
			const tl = gsap.timeline()

			tl.to('body', {
				overflow: 'hidden',
				duration: 0
			})

			tl.to('#cart-menu', {
				opacity: 1,
				visibility: 'visible',
				duration: 0
			})

			tl.to('.blur', {
				opacity: 1,
				pointerEvents: 'auto',
				duration: .3
			})

			tl.to('#cart-menu', {
				transform: 'none',
				duration: .3
			}, '-=.3s')
		})
	})

	// close cart
	function closeCart() {
		const tl = gsap.timeline()

		tl.to('body', {
			overflow: 'auto',
			duration: 0
		})

		tl.to('.blur', {
			opacity: 0,
			pointerEvents: 'none',
			duration: .3
		})

		tl.to('#cart-menu', {
			transform: 'translateX(110%)',
			duration: .3
		}, '-=.3s')

		tl.to('#cart-menu', {
			opacity: 0,
			visibility: 'hidden',
			duration: .3
		}, '-=.2s')

		tl.to('.blur', {
			pointerEvents: 'none',
			duration: 0
		})
	}

	// close cart menu
	document.querySelectorAll('.close-cart, .blur').forEach(function(el) {
		el.addEventListener('click', function() {
			closeCart()
		})
	})

	// close all opened menus when pressing the ESC key
	document.addEventListener('keyup', function(e) {
		if (e.key === 'Escape') {
			closeFs()
			closeCart()
		}
	})

	// mega menus
	const megaMenuItems = selectAll('.top-menu .menu li.has-sub')
	const hideTimeouts = new Map()

	function clearAllTimeouts() {
		hideTimeouts.forEach(timeout => clearTimeout(timeout))
		hideTimeouts.clear()
	}

	function hideAllSubMenus() {
		megaMenuItems.forEach(item => {
			const subMenu = item.querySelector('.sub-menu')
			item.classList.remove('active')
			subMenu.classList.remove('active')
		})
	}

	megaMenuItems.forEach(function(el) {

		const subMenu = el.querySelector('.sub-menu')

		function showSubMenu() {
			clearAllTimeouts()
			hideAllSubMenus()
			el.classList.add('active')
			subMenu.classList.add('active')
		}

		function hideSubMenu() {
			const timeout = setTimeout(() => {
				el.classList.remove('active')
				subMenu.classList.remove('active')
				hideTimeouts.delete(el)
			}, 500)
			hideTimeouts.set(el, timeout)
		}

		el.addEventListener('mouseenter', showSubMenu)
		el.addEventListener('mouseleave', hideSubMenu)

		subMenu.addEventListener('mouseenter', showSubMenu)
		subMenu.addEventListener('mouseleave', hideSubMenu)
	})

	// increase / decrease quantity
	$('.quantity .increase').click(function() {
		var $input = $(this).closest('.quantity').find('input')
		var value = parseInt($input.val())
		if (value < 8) {
			$input.val(value + 1)
		}
	})
	
	$('.quantity .decrease').click(function() {
		var $input = $(this).closest('.quantity').find('input')
		var value = parseInt($input.val())
		if (value > 1) {
			$input.val(value - 1)
		}
	})

}

// init pencil banner
function initPencilBanner() {

	const banner = document.querySelector('.pencil-banner')

	// close pencil banner and store closed state in localStorage
	function closePencilBanner() {
		const tl = gsap.timeline()

		tl.to('.pencil-banner', {
			height: 0,
			duration: .3,
			onComplete: function() {
				tl.to('.pencil-banner', {
					display: 'none',
					duration: 0,
					onComplete: function() {
						const banner = document.querySelector('.pencil-banner')
						banner.remove()

						// store closed state in localStorage with timestamp (1 day expiration)
						try {
							const expirationTime = Date.now() + (24 * 60 * 60 * 1000) // 1 day in milliseconds
							localStorage.setItem('pencilBannerClosed', expirationTime.toString())
						} catch (e) {}
					}
				})
			}
		})
	}

	// hide pencil banner on load if closed before
	document.addEventListener('DOMContentLoaded', function() {
		try {
			const storedValue = localStorage.getItem('pencilBannerClosed')
			const currentTime = Date.now()
			
			// Check if banner was closed and if the expiration time hasn't passed
			if (storedValue && parseInt(storedValue) > currentTime) {
				// Banner was closed and is still within the 1-day expiration period
				return
			} else {
				// Banner was not closed or has expired, show it
				const banner = document.querySelector('.pencil-banner')

				if (banner) {
					banner.classList.add('visible')
				}
			}
		} catch (e) {}
	})

	document.querySelectorAll('.pencil-banner .close').forEach(function(el) {
		el.addEventListener('click', function() {
			closePencilBanner()
		})
	})
	
}

// init floating product recommendation
function initFloatingProductRecommendation() {

	const banner = document.querySelector('.floating-product-recommendation')

	function closeFloatingProductRecommendation() {
		const tl = gsap.timeline()

		tl.to('.floating-product-recommendation', {
			x: '120%',
			opacity: 0,
			duration: .4,
			onComplete: function() {
				tl.to('.floating-product-recommendation', {
					display: 'none',
					duration: 0,
					onComplete: function() {
						banner.remove()

						// store closed state in localStorage with timestamp (1 day expiration)
						try {
							const expirationTime = Date.now() + (24 * 60 * 60 * 1000) // 1 day in milliseconds
							localStorage.setItem('floatingProductRecommendationClosed', expirationTime.toString())
						} catch (e) {}
					}
				})
			}
		})
	}

	// hide floating product recommendation on load if closed before
	document.addEventListener('DOMContentLoaded', function() {
		try {
			const storedValue = localStorage.getItem('floatingProductRecommendationClosed')
			const currentTime = Date.now()
			
			// Check if banner was closed and if the expiration time hasn't passed
			if (storedValue && parseInt(storedValue) > currentTime) {
				// Banner was closed and is still within the 1-day expiration period
				return
			} else {
				if (banner) {
					setTimeout(() => {
						banner.classList.add('visible')
					}, 3000)
				}
			}
		} catch (e) {}
	})

	document.querySelectorAll('.floating-product-recommendation .close-button').forEach(function(el) {
		el.addEventListener('click', function() {
			closeFloatingProductRecommendation()
		})
	})

}

// init all sliders
function initSliders() {

	// banner slider
	if(selectAll('.banner-slider').length) {

		const banner_slider = new Swiper('.banner-slider', {
			slidesPerView: 1,
			loop: true,
			simulateTouch: true,
			allowTouchMove: true,
			spaceBetween: 0,
			pagination: {
				el: '.banner-slider-pagination',
				type: 'bullets',
				clickable: true
			},
			mousewheel: {
				forceToAxis: true
			},
			autoplay: {
				delay: 6000
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			}
		})
	}

	// also like top slider
	if(selectAll('.also-like-top-slider').length) {

		const also_like_top_slider = new Swiper('.also-like-top-slider', {
			slidesPerView: 2,
			loop: false,
			simulateTouch: true,
			allowTouchMove: true,
			spaceBetween: 30,
			breakpoints: {
				575: {
					slidesPerView: 3,
					spaceBetween: 30
				}
			}
		})
	}

	// testimonial slider
	if(selectAll('.testimonial-slider').length) {

		const testimonial_slider = new Swiper('.testimonial-slider', {
			slidesPerView: 1,
			loop: true,
			simulateTouch: true,
			autoHeight: true,
			allowTouchMove: true,
			spaceBetween: 0,
			pagination: {
				el: '.testimonial-slider-pagination',
				type: 'bullets',
				clickable: true
			},
			mousewheel: {
				forceToAxis: true
			},
			autoplay: {
				delay: 6000
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			}
		})
	}

	// fading-logos-slider
	if(selectAll('.fading-logos-slider').length) {

		const fading_logos_slider = new Swiper('.fading-logos-slider', {
			slidesPerView: 2,
			simulateTouch: true,
			allowTouchMove: true,
			spaceBetween: 10,
			mousewheel: {
				forceToAxis: true
			},
			autoplay: {
				delay: 0,
				disableOnInteraction: false
			},
			loop: true,
			speed: 2000,
			breakpoints: {
				575: {
					slidesPerView: 3,
					spaceBetween: 15,
					autoplay: {
						delay: 0,
						disableOnInteraction: false
					},
					loop: true
				},
				992: {
					slidesPerView: 4,
					spaceBetween: 20,
					autoplay: {
						delay: 0,
						disableOnInteraction: false
					},
					loop: true
				},
				1200: {
					slidesPerView: 5,
					spaceBetween: 30,
					autoplay: false,
					loop: false
				}
			}
		})
	}

	// slider-section
	if(selectAll('.slider-section').length) {

		const slider_section = selectAll('.slider-section')

		slider_section.forEach(section => {
			const slider = section.querySelector('.slider-section__slider')
			const navigation = section.querySelector('.slider-section__navigation')
			const prev = navigation.querySelector('.prev')
			const next = navigation.querySelector('.next')
			const scrollbar = section.querySelector('.swiper-scrollbar')

			const swiper = new Swiper(slider, {
				slidesPerView: 1.1,
				spaceBetween: 15,
				mousewheel: {
					forceToAxis: true
				},
				navigation: {
					nextEl: next,
					prevEl: prev
				},
				scrollbar: {
					el: scrollbar,
					hide: false,
				},
				breakpoints: {
					575: {
						slidesPerView: 2.2,
						spaceBetween: 20
					},
					768: {
						slidesPerView: 3.2,
						spaceBetween: 30
					},
				}
			})
		})
	}

	// shop by space size slider
	if(selectAll('.shop-by-space-size__slider').length) {

		const swiper = new Swiper('.shop-by-space-size__slider', {
			slidesPerView: 1.1,
			spaceBetween: 15,
			mousewheel: {
				forceToAxis: true
			},
			navigation: {
				nextEl: '.shop-by-space-size__navigation .next',
				prevEl: '.shop-by-space-size__navigation .prev'
			},
			scrollbar: {
				el: '.slider-section__slider .swiper-scrollbar',
				hide: false
			},
			breakpoints: {
				575: {
					slidesPerView: 2.2,
					spaceBetween: 20
				},
				768: {
					slidesPerView: 3.2,
					spaceBetween: 30
				},
				992: {
					slidesPerView: 4,
					spaceBetween: 30
				}
			}
		})
	}

	// bottom reviews slider
	if(selectAll('.bottom-reviews__slider').length) {

		const swiper = new Swiper('.bottom-reviews__slider', {
			slidesPerView: 1.4,
			spaceBetween: 15,
			mousewheel: {
				forceToAxis: true
			},
			scrollbar: {
				el: '.bottom-reviews__slider .swiper-scrollbar',
				hide: false
			},
			breakpoints: {
				575: {
					slidesPerView: 2.2,
					spaceBetween: 20
				},
				768: {
					slidesPerView: 3.2,
					spaceBetween: 20
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 20
				}
			}
		})
	}

	// videos slider
	if(selectAll('.product-slider').length) {

		const product_videos = new Swiper('.videos-slider', {
			centeredSlides: true,
			centeredSlidesBounds: true,
			spaceBetween: 20,
			slidesPerView: 1.2,
			watchOverflow: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			scrollbar: {
				el: '.videos-slider .swiper-scrollbar',
				hide: false
			},
			breakpoints: {
				575: {
					slidesPerView: 2
				},
				768: {
					slidesPerView: 3
				},
				1200: {
					slidesPerView: 4
				}
			}
		})

	}

	// tabs-slider
	if(selectAll('.tabs-slider').length) {

		const tabs_slider = new Swiper('.tabs-slider', {
			slidesPerView: 1,
			loop: false,
			simulateTouch: false,
			allowTouchMove: false,
			spaceBetween: 0,
			autoHeight: true,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: '.tabs-section .tabs',
				clickable: true,
				renderBullet: function(index, className) {
					let title = this.slides[index].getAttribute('data-title')
					return '<button class="' + className + ' uppercase text-20">' + title + '</button>'
				}
			}
		})
	}

	// quiz slider
	if(selectAll('.quiz-slider').length) {

		const quiz_section = select('.quiz-slider')

		const quiz_slider = new Swiper('.quiz-slider', {
			slidesPerView: 1,
			loop: false,
			simulateTouch: false,
			allowTouchMove: false,
			spaceBetween: 0,
			autoHeight: true,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			}
		})

		const prev = quiz_section.querySelectorAll('[data-prev]')
		const next = quiz_section.querySelectorAll('[data-next]')

		prev.forEach(el => {
			el.addEventListener('click', function() {
				quiz_slider.slidePrev()
			})
		})

		next.forEach(el => {
			el.addEventListener('click', function() {
				quiz_slider.slideNext()
			})
		})
	}

}

// init fancybox
function initFancybox() {
	Fancybox.bind('[data-fancybox]', {
		autoFocus: false,
		dragToClose: false,
		placeFocusBack: false
	})
}

// init form validation
function initFormValidation() {
	const forms = selectAll('form.form-validate')

	forms.forEach(form => {
		
		// disable browser validation for custom validation
		form.setAttribute('novalidate', true)
		
		const requiredFields = form.querySelectorAll('[required]')

		// validate a single field
		function validateField(field) {
			let valid = true
			let errorMessage = 'This field is required'
			
			if (field.type === 'checkbox' || field.type === 'radio') {
				valid = field.checked
			} else if (field.type === 'email') {
				valid = field.value.trim() !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)
				if (field.value.trim() !== '' && !valid) {
					errorMessage = 'Please enter a valid email address'
				}
			} else if (field.name === 'RepeatPassword' || field.id.includes('repeat-password')) {
				const passwordField = form.querySelector('[name="Password"], [id*="password"]:not([id*="repeat"])')
				valid = field.value.trim() !== '' && field.value === passwordField?.value
				if (field.value.trim() !== '' && !valid) {
					errorMessage = 'Passwords do not match'
				}
			} else {
				valid = field.value.trim() !== ''
			}

			const formLine = field.closest('.form-line')
			const lineWrapper = field.closest('.form-line')?.querySelector('.line-wrapper')
			let errorSpan = formLine ? formLine.querySelector('span.red.error') : null

			if (!valid) {
				if (formLine) formLine.classList.add('error')
				if (!errorSpan && lineWrapper) {
					const span = document.createElement('span')
					span.className = 'red error text-14'
					span.textContent = errorMessage
					lineWrapper.insertAdjacentElement('afterend', span)
				} else if (errorSpan) {
					errorSpan.textContent = errorMessage
				}
			} else {
				if (formLine) formLine.classList.remove('error')
				if (errorSpan) errorSpan.remove()
			}
			return valid
		}

		// on submit
		form.addEventListener('submit', function(e) {
			e.preventDefault()
			
			let allValid = true
			let firstInvalidField = null
			
			requiredFields.forEach(field => {
				if (!validateField(field)) {
					allValid = false
					if (!firstInvalidField) {
						firstInvalidField = field
					}
				}
			})
			
			if (!allValid) {
				if (firstInvalidField) {
					firstInvalidField.focus()
				}
				return
			}
			
		})

		// on input/type
		requiredFields.forEach(field => {
			field.addEventListener('input', function() {
				validateField(field)
				
				// if this is a password field, also validate the repeat password
				if (field.name === 'Password' || field.id.includes('password')) {
					const repeatPasswordField = form.querySelector('[name="RepeatPassword"], [id*="repeat-password"]')
					if (repeatPasswordField && repeatPasswordField.value.trim() !== '') {
						validateField(repeatPasswordField)
					}
				}
				
				// if this is repeat password, also validate the main password if it has errors
				if (field.name === 'RepeatPassword' || field.id.includes('repeat-password')) {
					const passwordField = form.querySelector('[name="Password"], [id*="password"]:not([id*="repeat"])')
					if (passwordField) {
						const passwordFormLine = passwordField.closest('.form-line')
						if (passwordFormLine && passwordFormLine.classList.contains('error')) {
							validateField(passwordField)
						}
					}
				}
			})
		})
	})
}

// confetti
function initConfetti() {
	document.addEventListener('DOMContentLoaded', function() {
		if(document.querySelector('.confetti')) {
			confetti({
				particleCount: 200,
				spread: 100,
				origin: {
					y: .7
				}
			})
		}
	})
}

// cookies
function initCookies() {
	document.addEventListener('DOMContentLoaded', function() {
		if(Cookies.get('update_newsletter') == 'true'){
			setTimeout(function() {
				setCookie("update_newsletter", "false", 1);
				select('.subscribe-success').click();	
			}, 1200);
	   }
	})
}

// init klaviyo newsletter discount
function initKlaviyoNewsletterDiscount() {
	document.addEventListener('DOMContentLoaded', function() {
		const klaviyoForm = document.querySelector('.klaviyo-form-W4UBMH')
		
		if (!klaviyoForm) return
		
		// Create a MutationObserver to watch for changes in the Klaviyo form
		const observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				mutation.addedNodes.forEach(function(node) {
					// Check if it's an element node
					if (node.nodeType === 1) {
						const textContent = node.textContent || node.innerText
						
						// Check if the success message appears
						if (textContent.includes('Thank you') && textContent.includes('Your coupon was applied at checkout')) {
							console.log('Klaviyo form submitted successfully, applying discount...')
							
							// Apply the discount by redirecting to /discount/10OFF
							window.location.href = '/discount/GET10'
							
							// Disconnect observer after applying discount
							observer.disconnect()
						}
					}
				})
			})
		})
		
		// Start observing the Klaviyo form for child list changes and subtree modifications
		observer.observe(klaviyoForm, {
			childList: true,
			subtree: true
		})
	})
}

// fire all scripts
function initScripts() {
	initClickAndKeyFunctions()
	initSliders()
	initFancybox()
	initFormValidation()
	initLucide()
	initFloatingProductRecommendation()
	initPencilBanner()
	initConfetti()
	initCookies()
	initKlaviyoNewsletterDiscount()
}

initScripts()

$(document).ready(function () {
	var currentPath = window.location.pathname;
	if (currentPath === "/cart") {
	   window.location.href = '/products?open-cart=true';
	}
 
	var queryString = window.location.search;  
	if (queryString.indexOf("open-cart=true") !== -1) {
		console.log('querystring', queryString);
		openCart();
	}

});

/* CART MONEY FORMATTING (2026-08-15, Managed Markets)
   ----------------------------------------------------------------
   /cart.js returns every amount in the buyer's PRESENTMENT currency
   (SEK, EUR, ...), NOT the shop's base currency. This code used to
   format those amounts with a hardcoded en-US / USD locale, which
   stamped a "$" onto correct SEK amounts in the cart drawer while the
   product page and checkout showed "kr". Resolve the currency at
   runtime instead, and never hardcode it again. */
function cartCurrency(cart) {
	if (cart && cart.currency) return cart.currency;
	if (window.Shopify && Shopify.currency && Shopify.currency.active) {
		return Shopify.currency.active;
	}
	return 'USD';
}

function cartMoneyLocale() {
	if (window.Shopify && Shopify.locale) return Shopify.locale;
	return document.documentElement.lang || 'en';
}

// cents is in MINOR units, as returned by /cart.js
function formatMoney(cents, currency) {
	var value = Number(cents) / 100;
	if (isNaN(value)) return '';
	try {
		return value.toLocaleString(cartMoneyLocale(), {
			style: 'currency',
			currency: currency
		});
	} catch (e) {
		return value.toFixed(2) + ' ' + currency;
	}
}

/* CART FUNCTIONS */
function fetchCart() {
	$.ajax({
		type: 'GET',
		url: '/cart.js',
		dataType: 'json',
		success: function (cart) {
			renderCart(cart);
		},
	});
}

const cartItem =
  `<div class='cart-product-block'>
    <div class="inner-wrapper">

      <a href='javascript:' class='image'>
        <img
          src='%PRODUCT_IMAGE%'
          alt='%PRODUCT_TITLE%'
          loading='lazy'
          class='cover'
        >
      </a>

      <div class='infos'>

        <p class='product-detail text-16'>
          %PRODUCT_TITLE%%VARIANT_SEPARATOR%%PRODUCT_VARIANT_TITLE%
        </p>
        %PRODUCT_PROPERTIES%

        <p class='bold product-price text-25'>
          <span class='current'>
            %PRODUCT_PRICE%
          </span>
        </p>

        <div class='bottom-part'>

          <div class='quantity'>
            <div class='form-line'>
              <div class='line-wrapper'>

                <input
                  class='input'
                  type='number'
                  value='%QUANTITY%'
                  min='1'
                  max='8'
                  placeholder='0'
                  id='quantity'
                  onfocusout="changeItem(%PRODUCT_ID%, this.value, %PRODUCT_PLAN_ID%)"
                />

                <button
                  class='increase'
                  aria-label='Increase quantity'
                  onClick='addQty(%PRODUCT_ID%, %QUANTITY%, %PRODUCT_PLAN_ID%)'
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="plus" class="lucide lucide-plus"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>
                </button>

                <button
                  class='decrease'
                  aria-label='Decrease quantity'
                  onClick='subQty(%PRODUCT_ID%, %QUANTITY%, %PRODUCT_PLAN_ID%)'
                >
				  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="minus" class="lucide lucide-minus"><path d="M5 12h14"></path></svg>
                </button>

              </div>
            </div>
          </div>

          <p class='subs-and-save text-14' %PRODUCT_PLAN_STYLE%>
            %PRODUCT_PLAN%
          </p>

        </div>

      </div>

      <button class='remove-product' onClick="changeItem(%PRODUCT_ID%, 0, %PRODUCT_PLAN_ID%)">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             data-lucide="trash-2" class="lucide lucide-trash-2">
          <path d="M10 11v6"></path>
          <path d="M14 11v6"></path>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
          <path d="M3 6h18"></path>
          <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        </svg>
      </button>

    </div>
  </div>`;

function changeItem(productId, quantity, sellingPlanId = null) {
    $("#cart-menu .wrapper").css("opacity", ".2");

    if (quantity > 10) {
        quantity = 10;
    }

    $.getJSON('/cart.js', function(cart) {
        let line = null;

        cart.items.forEach((item, index) => {
            if (item.id === productId) {                
                const hasSellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id === sellingPlanId;
                
                if ((!sellingPlanId && !item.selling_plan_allocation) || hasSellingPlan) {
                    line = index + 1;
                }
            }
        });

        if (line !== null) {            
            const data = {
                quantity: quantity,
                line: line
            };

            if (sellingPlanId) {
                data.selling_plan = sellingPlanId;
            }

            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: data,
                dataType: 'json',
                success: function(cart) {
                    renderCart(cart);
                    $("#cart-menu .wrapper").css("opacity", "1");					
                },
                error: function() {
                    console.error("Error modifying the item in the cart.");
                    $("#cart-menu .wrapper").css("opacity", "1");
                }
            });
        } else {
            console.log("Item with the specified plan not found in the cart.");
            $("#cart-menu .wrapper").css("opacity", "1");
        }
    });
}

let nQty = 0;

function addQty(productId, quantity, sellingPlanId = null) {
	$("#cart-menu .wrapper").css("opacity", ".2");

	var nquantity = quantity + 1;
	nquantity = nquantity > 10 ? 10 : nquantity;

	// Use the same logic as changeItem to find the correct line
	$.getJSON('/cart.js', function(cart) {
		let line = null;

		cart.items.forEach((item, index) => {
			if (item.id === productId) {                
				const hasSellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id === sellingPlanId;
				
				if ((!sellingPlanId && !item.selling_plan_allocation) || hasSellingPlan) {
					line = index + 1;
				}
			}
		});

		if (line !== null) {
			$.ajax({
				type: 'POST',
				url: '/cart/change.js',
				data: 'quantity=' + nquantity + '&line=' + line,
				dataType: 'json',
				success: function (cart) {
					renderCart(cart);
					$("#cart-menu .wrapper").css("opacity", "1");
				},
				error: function() {
					console.error("Error adding quantity to cart item.");
					$("#cart-menu .wrapper").css("opacity", "1");
				}
			});
		} else {
			console.log("Item with the specified plan not found in the cart.");
			$("#cart-menu .wrapper").css("opacity", "1");
		}
	});
}

function subQty(productId, quantity, sellingPlanId = null) {
	$("#cart-menu .wrapper").css("opacity", ".2");

	var nquantity = quantity - 1;
	nquantity = nquantity > 10 ? 10 : nquantity;

	// Use the same logic as changeItem to find the correct line
	$.getJSON('/cart.js', function(cart) {
		let line = null;

		cart.items.forEach((item, index) => {
			if (item.id === productId) {                
				const hasSellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id === sellingPlanId;
				
				if ((!sellingPlanId && !item.selling_plan_allocation) || hasSellingPlan) {
					line = index + 1;
				}
			}
		});

		if (line !== null) {
			$.ajax({
				type: 'POST',
				url: '/cart/change.js',
				data: 'quantity=' + nquantity + '&line=' + line,
				dataType: 'json',
				success: function (cart) {
					renderCart(cart);
					$("#cart-menu .wrapper").css("opacity", "1");
				},
				error: function() {
					console.error("Error subtracting quantity from cart item.");
					$("#cart-menu .wrapper").css("opacity", "1");
				}
			});
		} else {
			console.log("Item with the specified plan not found in the cart.");
			$("#cart-menu .wrapper").css("opacity", "1");
		}
	});
}

function renderCart(cart) {

	const cartItemHolder = $("#products");

	cartItemHolder.empty();

	if (cart.items.length != 0) {
		$("#empty").css("display", "hidden");
		$("#empty").css("display", "none");
		cartItemHolder.removeClass("hidden");
		$('#protection').css("display", "block");
	} else {
		$("#empty").css("display", "block");
		cartItemHolder.addClass("hidden");
		$('#protection').css("display", "none");
	}

	var cartCount = $(".cart-items.text-small");

	cartCount.text(cart.item_count);

	// resolve the buyer's currency once for this render
	var currency = cartCurrency(cart);

	var subtotalValue = cart.items_subtotal_price / 100;
	var subtotal = formatMoney(cart.items_subtotal_price, currency);

	let subtotalold = 0;

	var cartCountItems = 0;

	cart.items.forEach(function (item, index) {

		var originalPrice = formatMoney(item.price / 0.85, currency);

		var cost = formatMoney(item.price, currency);

		var sellingPlanName = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) ? item.selling_plan_allocation.selling_plan.name : "";	
		var sellingPlanId = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) ? item.selling_plan_allocation.selling_plan.id : "";	

		var cartItem2 = replaceAll(cartItem, "%PRODUCT_TITLE%", item.product_title);

		if (item.variant_title && item.variant_title !== "Default Title") {			
			cartItem2 = replaceAll(cartItem2, "%VARIANT_SEPARATOR%", " / ");
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_VARIANT_TITLE%", item.variant_title);
		} else {
			cartItem2 = cartItem2.replace(/<p\s+class=(?:"|')[^"']*\btext-smaller\b[^"']*\bproduct-detail\b[^"']*(?:"|')[^>]*>[\s\S]*?<\/p>/g, "");			
			cartItem2 = replaceAll(cartItem2, "%VARIANT_SEPARATOR%", "");
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_VARIANT_TITLE%", "");
		}

		// Pre-order (2026-09-25): show visible line-item properties in the drawer, e.g. "Pre-order: Ships by Nov 10, 2026".
		// Keys starting with "_" are Shopify's hidden-property convention and stay hidden. Values are HTML-escaped.
		var propsHtml = '';
		if (item.properties && typeof item.properties === 'object') {
			Object.keys(item.properties).forEach(function (k) {
				var v = item.properties[k];
				if (k && k.charAt(0) !== '_' && v !== null && v !== undefined && String(v) !== '') {
					propsHtml += "<p class='text-14 cart-line-property' style='margin:0.25rem 0 0;'><strong>" + aromifyEscapeHtml(k) + ":</strong> " + aromifyEscapeHtml(String(v)) + "</p>";
				}
			});
		}
		cartItem2 = cartItem2.replace('%PRODUCT_PROPERTIES%', function () { return propsHtml; });
		cartItem2 = replaceAll(cartItem2, "%QUANTITY%", item.quantity);
		cartItem2 = replaceAll(cartItem2, "%ID%", item.id);
		cartItem2 = replaceAll(cartItem2, "%PRODUCT_IMAGE%", (item.image).replace(".png", "_500x500.png").replace(".jpg", "_500x500.jpg"));

		cartItem2 = replaceAll(cartItem2, "%PRODUCT_PRICE%", cost);
		
		let lineUnitPrice = item.price / 100;

		if(sellingPlanName === ""){
			cartItem2 = cartItem2.replace(/<span class=['"]old['"][^>]*>[\s\S]*?<\/span>/g, "");
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PRICE_OLD%", null);			
			subtotalold += parseFloat(lineUnitPrice) * item.quantity;
		}
		else {
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PRICE_OLD%", originalPrice);
			let originalSubTotal = lineUnitPrice / 0.85;
			subtotalold += parseFloat(originalSubTotal) * item.quantity;
		}

		if (sellingPlanName === "") {
			// No subscription - hide the element and clear the plan ID
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN_STYLE%", 'style="display: none;"');
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN%", "");
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN_ID%", null);
		} else {
			// Has subscription - show the element with the plan name
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN_STYLE%", '');
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN%", sellingPlanName);
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN_ID%", sellingPlanId);
		}

		cartItem2 = replaceAll(cartItem2, "%PRODUCT_ID%", item.id);
		cartItem2 = replaceAll(cartItem2, "%HANDLE%", item.handle);

		cartCountItems += parseInt(item.quantity);

		cartItemHolder.prepend(cartItem2);

	});

	$("#subtotal").text(subtotal);

	/* compare the numeric values, not the formatted strings. The old code did
	   parseFloat(subtotal.replace("$", "")) which returned 2.2 for "$2,200.00"
	   because of the thousands separator, so this branch misfired even in USD. */
	if (Math.round(subtotalValue * 100) !== Math.round(subtotalold * 100)) {
		$("#subtotalold").css("display", "inline");
		$("#subtotalold").text(formatMoney(subtotalold * 100, currency));
	}
	else{
		$("#subtotalold").css("display", "none");
	}

	$("#cartCount").text(cartCountItems);

	$("#loading").css("display", "none");
	
	// Dispatch custom event when renderCart is complete
	setTimeout(() => {
		const cartRenderCompleteEvent = new CustomEvent('cart:renderComplete');
		document.dispatchEvent(cartRenderCompleteEvent);
	}, 250);

}

function replaceAll(str, find, replace) {
	return str.replace(new RegExp(find, 'g'), replace);
}

// Pre-order (2026-09-25): minimal HTML escaper for cart-line property text
function aromifyEscapeHtml(str) {
	return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/%/g, '&#37;');
}

//shopify
function openCart() {
	const cartItemHolder = $("#products");
	cartItemHolder.empty();
	$("#loading").css("display", "block");
	$('body').toggleClass('cart-menu-open');
	setTimeout(() => {
		fetchCart();
		// initialize product functionality after cart is loaded
		setTimeout(() => {
			fetchCart();
		}, 500);
	}, 1000);
}

$('.shopify-product-form').submit(function () {

	console.log('post cart', $(this).serialize());

	$.ajax({
		type: 'POST',
		url: '/cart/add',
		data: $(this).serialize(),
		success: openCart()
	});
	return false;
});

$('.product-card').each(function(){

    var product = $(this);	

	product.find('.product-single__add-to-cart').click(function () {
		let addToCart = $(this);
		let idProd = addToCart.attr('data-productvariantid');
		let sellingPlan = addToCart.attr('data-selling-plan');
	
		console.log("Product ID: " + idProd);
		console.log("Selling Plan: " + sellingPlan);
	
		let requestData = {
			quantity: 1,
			id: idProd,
		};
	
		if (sellingPlan) {
			requestData.selling_plan = sellingPlan;
		}
	
		jQuery.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: requestData,
			dataType: 'json',
			success: function () {
				console.log("Product added successfully!");
			},
			error: function () {
				console.log(
					'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.'
				);
			},
		});
	});
});
